import { Reveal, SectionLabel } from "./ui";
import RichHTML from "../RichHTML";
import { FileCheck2 } from "lucide-react";

export default function Regulatorik({ data, index, appr }) {
  const chapters = data?.chapters || [];
  return (
    <section id="regulatorik" style={appr?.style} className={`py-20 lg:py-28 ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Reveal><SectionLabel index={index}>Der Kaufgrund: Ihre Betreiberpflicht</SectionLabel></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-head font-light tracking-tight text-[1.875em] lg:text-[2.6em] leading-tight mt-6 text-[var(--mf-ink)]">
                Betreiber von Medizin&shy;produkten stehen in der <span className="font-medium">Pflicht</span>.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-6 text-[var(--mf-ink-soft)] leading-relaxed text-[1.125em]"><RichHTML html={data?.intro} /></div>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-8 inline-flex items-center gap-3 text-sm font-head font-semibold text-[var(--mf-grey)] border border-[var(--mf-line)] px-4 py-3">
                <FileCheck2 size={18} className="text-[var(--mf-red)]" />
                Nach MPBetreibV · dokumentiert · nachweisbar
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="border-t border-[var(--mf-line)]">
              {chapters.map((c, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <div
                    data-testid={`regulatorik-${i}`}
                    className="group grid grid-cols-[auto_1fr] gap-6 py-7 border-b border-[var(--mf-line)] transition-colors hover:bg-[var(--mf-mist)]"
                  >
                    <span className="font-head text-2xl font-light text-[var(--mf-red)] tabular-nums">{c.no}</span>
                    <div>
                      <h3 className="font-head font-semibold text-[1.125em] text-[var(--mf-ink)]">{c.title}</h3>
                      <p className="mt-2 text-[1em] text-[var(--mf-ink-soft)] leading-relaxed">{c.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
